/* @ngInject */
const sterileFields = (
  sterileLabels,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: sterileLabels.fields.id.text,
    output: false,
  }
  self.name = {
    ref: 'name',
    label: sterileLabels.fields.name.text,
    icon: icons.sterile.name,
    type: types.text(),
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },

  }
  self.weight = {
    ref: 'weight',
    label: sterileLabels.fields.weight.text,
    icon: icons.sterile.weight,
    type: types.decimal,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },

  }

  return self
}
export default sterileFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/resources/fields.resource.js